<template>
  <div class="fixed z-10 inset-0 overflow-y-auto" v-show="state.isModalOpen">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <transition
        enter-active-class="ease-out duration-300"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="ease-in duration-200"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          class="fixed inset-0 transition-opacity"
          v-show="state.isModalOpen"
        >
          <div
            class="absolute inset-0 bg-gray-500 opacity-75 cursor-pointer"
            @click="state.isModalOpen = false"
          ></div>
        </div>
      </transition>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
        >&#8203;</span
      >
      <transition
        enter-active-class="ease-out duration-300"
        enter-from-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-from-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      >
        <div
          class="inline-block align-bottom bg-gray-900 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full h-96"
          role="dialog"
          v-show="state.isModalOpen"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div class="flex h-full w-full">
            <div
              class="h-full w-1/2 bg-gray-800 flex flex-wrap content-center p-6"
            >
              <div class="leading-tight w-full">
                <h1 class="text-3xl text-white font-bold">Get Started</h1>
                <h1 class="text-md text-white font-light mb-4">
                  With Raspberry Pi Pico + Python
                </h1>
                <h1 class="text-lg text-white mb-2">
                  1. Download MicroPython
                </h1>
                <a
                  href="https://www.raspberrypi.org/documentation/pico/getting-started/static/5d8e777377e8dbe23cf36360d6efc727/pico_micropython_20210121.uf2"
                >
                  <button
                    type="button"
                    class="w-full mb-4 px-4 py-2 border border-transparent text-base text-ce font-medium rounded-md shadow-sm text-white bg-blue-500 hover:bg-blue-700 focus:outline-none"
                  >
                    Download
                  </button>
                </a>
                <h1 class="text-lg text-white mb-2">
                  2. Hold
                  <span class="text-blue-500 font-bold">BOOTSEC</span> and plug
                  your pico into a USB port.
                </h1>
                <h1 class="text-lg text-white mb-2">
                  3. Drag + Drop the MicroPython UF2 file and then download your
                  code to the RPI-RP2 drive.
                </h1>
              </div>
            </div>
            <div class="h-full w-1/2 flex items-center justify-center">
              <div>
                <h1
                  class="text-3xl text-white font-bold w-full text-center mb-8"
                >
                  Your code
                </h1>
                <slot />
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { state } from "@/state";

export default defineComponent({
  name: "Modal",
  setup() {
    return { state };
  }
});
</script>
